import React from 'react';
import { Outlet, useLocation } from 'react-router';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from './app-sidebar';
import { GlobalHeader } from './global-header';
import { AppsDataProvider } from '@/contexts/apps-data-context';
import { useAuth } from '@/contexts/auth-context';
import clsx from 'clsx';

interface AppLayoutProps {
  children?: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const { pathname } = useLocation();
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  // Suppress app header/sidebar on `/` for signed-out visitors so LandingPage's TopNav owns the header band.
  const isAnonymousLanding = pathname === '/' && (isAuthLoading || !isAuthenticated);

  return (
    <AppsDataProvider>
      <SidebarProvider
        defaultOpen={false}
        style={{
          "--sidebar-width": "320px",
          "--sidebar-width-mobile": "280px",
          "--sidebar-width-icon": "52px"
        } as React.CSSProperties}
      >
        {!isAnonymousLanding && <AppSidebar />}
        <SidebarInset className={clsx("bg-bg-3 flex flex-col h-screen relative", pathname !== "/" && "overflow-hidden")}>
          {!isAnonymousLanding && <GlobalHeader />}
          <div className={clsx("flex-1 bg-bg-3", pathname !== "/" && "min-h-0 overflow-auto")}>
            {children || <Outlet />}
          </div>
        </SidebarInset>
      </SidebarProvider>
    </AppsDataProvider>
  );
}